<template>
  <v-hover v-slot="{ hover }">
    <v-card outlined
      :class="{ 'elevation-5': hover }"
      @click="$router.push({ path: '/students/list' })"
      style="transition: transform 0.3s"
      :style="{ transform: hover ? 'scale(1.02)' : 'scale(1)' }"
    >
      <v-card-text>
        <div class="d-flex justify-space-between align-center">
          <div>
            <div class="text-subtitle-2 grey--text text-uppercase">
              Students
            </div>
            <div class="text-h5 font-weight-bold">
              <v-progress-circular
                v-if="isLoading"
                size="50"
                width="5"
                color="white"
                indeterminate
              ></v-progress-circular>
              <animated-number
                v-else
                class="display-3 font-weight-light"
                :value="amount"
                :formatValue="formatToNumber"
                :duration="1000"
              ></animated-number>
            </div>
            <v-btn text small class="mt-2" color="primary"
              >View Total Students</v-btn
            >
          </div>
          <v-img max-width="80" src="@/assets/AdminTools/graduated.png"></v-img>
        </div>
      </v-card-text>
    </v-card>
  </v-hover>

  
</template>

<script>
import studentService from "@/modules/Student/service.js";
import AnimatedNumber from "animated-number-vue";

export default {
  data() {
    return {
      isLoading: true,
      amount: 0,
    };
  },
  components: {
    AnimatedNumber,
  },
  created() {
    this.loadData();
  },
  methods: {
    formatToNumber(value) {
      return `${value.toFixed(0)}`;
    },
    loadData() {
      studentService.getStudentCount().then((response) => {
        this.amount = response.count;

        this.isLoading = false;
      });
    },
  },
};
</script>

<style scoped></style>
